"use client";

import { Check } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
export default function GratisOfferte() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: listRef,
    isVisible: listVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: logoRef,
    isVisible: logoVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const benefits = ["Snelle en professionele service", "Vaste contactpersoon gedurende het hele proces", "Duidelijke en transparante prijsstructuur", "Klantgerichte aanpak met persoonlijke aandacht", "Flexibele planning die aansluit bij uw agenda"];
  return <section className="bg-light-background py-20">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {}
          <div ref={listRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${listVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <h2 ref={headingRef} className={`text-3xl font-semibold mb-8 text-foreground transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${headingVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
              Gratis offerte aanvragen
            </h2>
            <Card className="shadow-soft border border-border bg-background p-6">
              <ul className="space-y-4">
                {benefits.map((benefit, i) => <li key={i} data-index={i} className={`flex items-start gap-3 transition-all ease-[var(--ease-smooth)] ${listVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-6"}`} style={{
                transitionDuration: "var(--duration-medium)",
                transitionDelay: listVisible ? `${i * 80}ms` : "0ms"
              }}>
                    <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center transition-transform duration-[var(--duration-fast)] ease-[var(--ease-spring)] hover:scale-110">
                      <Check className="w-4 h-4 text-primary" />
                    </div>
                    <span className="text-foreground leading-relaxed">
                      {benefit}
                    </span>
                  </li>)}
              </ul>
            </Card>
          </div>

          {}
          <div ref={logoRef} className={`flex justify-center items-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${logoVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1511866/img/ekonorm_corporate_logo.png" alt="Ekonorm logo" className="w-full max-w-md h-auto object-contain" />
          </div>
        </div>
      </div>
    </section>;
}